import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AddBalanceDTO  {
    _originalTypeClassName = "zvelton_Backoffice.BO.AddBalanceDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AddBalanceDTO.translate = translateService;
}
this.AmountEUR = null;
this.PaymentMethodId = null;
this.Reference = null;
this.CurrencyCode = null;
this.ApplyImmediately = false;
this.AddBalanceDTOKey = null;
this._key = this.AddBalanceDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
AmountEUR:any;
PaymentMethodId:any;
Reference:any;
CurrencyCode:any;
ApplyImmediately:any;
private _AddBalanceDTOKey:any;
get AddBalanceDTOKey(): any {
    return this._AddBalanceDTOKey;
  }
set AddBalanceDTOKey(value: any) {
    this._AddBalanceDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AddBalanceDTOKey == null || $this.AddBalanceDTOKey == 0;
            }


}